import tw from 'twin.macro';
import Card from 'components/Card';

interface Props {
  count?: number;
}

export function CustomFieldSkeletons({ count = 3 }: Props) {
  return (
    <div tw="flex flex-col gap-y-4">
      {Array.from({ length: count }, (_, i) => (
        <Card tw="mb-3 relative" key={i}>
          <div tw="space-y-4 p-4">
            <div className="tsh-skeleton" css={tw`w-1/4 h-6`} />
            <div tw="space-y-2">
              <div className="tsh-skeleton" css={tw`w-3/4 h-4`} />
              <div className="tsh-skeleton" css={tw`w-2/3 h-4`} />
            </div>
          </div>
        </Card>
      ))}
    </div>
  );
}
